



































import Vue from "vue";
import { axios } from "@/plugins";
import { Header } from "../MyTable.vue";

const TableHeaders: Header[] = [
  { title: "名称", minWidth: 220 },
  { title: "容量", width: 200 },
  { title: "命名空间", minWidth: 220 },
  { title: "创建时间", width: 180 }
];

export default Vue.extend({
  name: "StorageInfo",
  props: {
    tenantId: {
      type: String
    }
  },
  data() {
    return {
      dialog: false,
      TableHeaders,
      tableData: [] as any[]
    };
  },
  methods: {
    show(data: any) {
      this.dialog = true;
      this.getData(data.metadata.name);
    },
    close() {
      this.dialog = false;
    },
    getData(storageClassName: string) {
      axios
        .get(`/storageclass/pvc/${this.tenantId}/${storageClassName}`)
        .then(res => {
          this.tableData = res.data.data;
        });
    }
  }
});
